import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#unique_course",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Unique Course Details")
  ])
], -1)
const _hoisted_3 = {
  id: "unique_course",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_13 = {
  key: 1,
  disabled: "",
  type: "button",
  class: "btn btn-success mt-6 p-3",
  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  id: "unique_course_data",
  class: "collapse show"
}
const _hoisted_19 = { class: "collapse show" }
const _hoisted_20 = { class: "card-body p-0 mt-5" }
const _hoisted_21 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_22 = { class: "row w-100 mb-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 my-auto" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "m-0" }, "Unique Course Details")
], -1)
const _hoisted_24 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 0,
  class: "commaSeparator"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_UniqueCourseDrawer = _resolveComponent("UniqueCourseDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.selectedTranche,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTranche) = $event)),
                    options: _ctx.optionsTranche,
                    onChange: _ctx.btnCheckStatus,
                    mode: "tags",
                    "clear-on-select": false,
                    placeholder: "Select Training Partner",
                    "close-on-select": false,
                    searchable: true,
                    "create-option": true
                  }, null, 8, ["modelValue", "options", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.btnCheck)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.courseInfoUnique())),
                        type: "button",
                        class: "btn btn-success mt-6 p-3",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                      }, [
                        _createTextVNode(" Search "),
                        _hoisted_12
                      ]))
                    : (_openBlock(), _createElementBlock("button", _hoisted_13, [
                        _createTextVNode(" Search "),
                        _hoisted_14
                      ]))
                ])
              ]),
              (_ctx.showCourseNotice == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                : _createCommentVNode("", true),
              (_ctx.showCourseNotice == true)
                ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _hoisted_23,
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                  title: "Download Xlse",
                                  "data-v-54b12dc8": "",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportTrainee()))
                                }, _hoisted_26),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                  title: "Download PDF",
                                  "data-v-54b12dc8": "",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadPdf()))
                                }, _hoisted_28),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                  title: "Print",
                                  "data-v-54b12dc8": "",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.printPdf()))
                                }, _hoisted_30)
                              ])
                            ]),
                            _createVNode(_component_Datatable, {
                              "table-data": _ctx.uniqueCourseList,
                              "table-header": _ctx.tableHeader,
                              "enable-items-per-page-dropdown": true
                            }, {
                              "cell-unique_course": _withCtx(({ row: uniqueCourse }) => [
                                _createTextVNode(_toDisplayString(uniqueCourse?.course_alias?.name), 1)
                              ]),
                              "cell-code": _withCtx(({ row: uniqueCourse }) => [
                                _createTextVNode(_toDisplayString(uniqueCourse?.course_alias?.code), 1)
                              ]),
                              "cell-association": _withCtx(({ row: uniqueCourse }) => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueCourse?.entity, (item, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (item?.active_status == 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item?.entity_short_name), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ]),
                              "cell-course": _withCtx(({ row: uniqueCourse }) => [
                                _createTextVNode(_toDisplayString(uniqueCourse?.course_count), 1)
                              ]),
                              "cell-actions": _withCtx(({ row: uniqueCourse }) => [
                                _createElementVNode("button", {
                                  title: "View Courses",
                                  onClick: ($event: any) => (_ctx.view(uniqueCourse?.course_info)),
                                  "data-kt-drawer-toggle": "true",
                                  "data-kt-drawer-target": "#kt_drawer_unique_course",
                                  id: "kt_drawer_unique_course_button",
                                  class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                }, _hoisted_34, 8, _hoisted_32)
                              ]),
                              _: 1
                            }, 8, ["table-data", "table-header"])
                          ])
                        ])
                      ])
                    ])
                  ])), [
                    [_directive_loading, _ctx.load]
                  ])
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ]),
    _createVNode(_component_UniqueCourseDrawer)
  ], 64))
}